import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import { Proveedor } from "src/app/models/Proveedor/Proveedor";
import { ProveedorFilter } from "src/app/models/Proveedor/ProveedorFilter";
import { ProveedorService } from "src/app/services/proveedor.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import Swal from "sweetalert2";
import { ConfigMantenedorProveedor } from "./config-mantenedor-proveedor";
import { PermissionService } from "src/app/services/permission.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { zip } from "rxjs";
import { ProveedorRulesRequest } from "src/app/models/Proveedor/ProveedorRulesRequest";
import { TipoReferencium } from "src/app/models/Proveedor/TipoReferencium";
import { SortType } from "@swimlane/ngx-datatable";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';
import { ListaProveedorEnum,EstadoProveedorOption } from "src/app/models/Proveedor/ListaEstadoProveedor";
@Component({
	selector: "app-mantenedor-proveedor",
	templateUrl: "./mantenedor-proveedor.component.html",
	styleUrls: ["./mantenedor-proveedor.component.scss"],
})
export class MantenedorProveedorComponent implements OnInit {
	SortType = SortType;
	public loading = false;
	public page = new Page();
	public filter = new ProveedorFilter();
	public rowsMantenedor: Proveedor[] = [];
	public configLocal = ConfigMantenedorProveedor;
	public searchRows: any[] = [];
	public selected: Proveedor[] = [];
	public proveedorToShow: Proveedor = new Proveedor();
	public proveedorToEdit: Proveedor = new Proveedor();
	private saveRows: boolean = false;
	public detailProveedorModal: NgbModalRef;
	public addNewProveedorModal: NgbModalRef;
	public editProveedorModal: NgbModalRef;
	public rulesProveedorModalRef: NgbModalRef;
	public searchCriterio;
	public newRazonSocial = "";
	public newRut = "";
	// public newDirPart = "";
	public newDirFact = "";
	public newCorreoPart = "";
	public newGiro = "";
	public newCiudad = "";
	public newComuna = "";
	public newCasilla = "";
	public newAcuseReciboAutomatico: boolean = false;
	public newProveedor: Proveedor;
	@ViewChild("currentSwal") private currentSwal: SwalComponent;
	@ViewChild("notesSwal") private notesSwal: SwalComponent;
	private emisorId: string = this.tokenStorage.getCompany();
	public componentStarted: boolean = false;
	@ViewChild("tableMobile") tableRef: any;
	private closeActionsHandler: any;
	public codeReferences: TipoReferencium[] = [];
	public selectedAllItemsInPage: any = {};
	ListaProveedorEnum = ListaProveedorEnum;
	
	public estadoProveedorOptions: EstadoProveedorOption[] = [
		{ id: ListaProveedorEnum.ListaBlanca, descripcion: 'Lista Blanca' },
		{ id: ListaProveedorEnum.ListaNegra,  descripcion: 'Lista Negra'  },
		{ id: ListaProveedorEnum.Desconocido,  descripcion: 'Desconocido'  },
	];

	public newListaProveedor: number = null;
	constructor(private modalService: NgbModal, public utilities: UtilitiesService, private proveedorService: ProveedorService, private ref: ChangeDetectorRef, public permissions: PermissionService, private tokenStorage: TokenStorageService, private localStorage: LocalStorageService,private sessionUserService: SessionUserService) {
		this.filter.ciudad = "";
		this.filter.comuna = "";
		this.filter.razonSocial = "";
		this.filter.rut = "";
		this.filter.giro = "";
		this.filter.activo = true;
		this.newProveedor = new Proveedor();
	}

	toggleActions(row: any): void {
		const newState = !row.showActions;
		this.rowsMantenedor.forEach(r => {
		  if (r !== row && r.showActions) {
			r.showActions = false;
			document.removeEventListener('click', this.closeActionsHandler);
		  }
		});
	  
		row.showActions = newState;
	  
		if (newState) {
		  this.closeActionsHandler = this.closeActionsMenu.bind(this, row);
		  setTimeout(() => document.addEventListener('click', this.closeActionsHandler), 0);
		} else {
		  document.removeEventListener('click', this.closeActionsHandler);
		}
	  }
	  
	closeActionsMenu(row: any, event: MouseEvent): void {
		if (!(event.target as HTMLElement).closest('.action-container')) {
			row.showActions = false;
			this.ref.detectChanges();
			document.removeEventListener('click', this.closeActionsHandler);
		}
	}
    
   
	public getTotalPages(rowCount: number, pageSize: number): number {
		if (!pageSize) { 
		  return 1; 
		}
		return Math.ceil(rowCount / pageSize);
	  }


	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		this.filter.emisorId = this.emisorId;
		this.filter.activo = true;
		this.getCodeReferencesList();
		this.getXMLTagList();
		this.starterPage();
		this.setPage({ offset: 0 });
	}
	setPageSize() {
		//this.page.currentPageSize = this.page.page
		this.setPage({ offset: 0 });
	}
	selectAll(event) {
		if (!this.selectedAllItemsInPage[this.page.pageNumber]) {
			if (this.selected.length > 0) {
			this.rowsMantenedor.map((proveedor) => {
				this.selected = this.selected.filter(
				(selectedProveedor) => selectedProveedor.proveedorId !== proveedor.proveedorId
				);
			});
			}
			this.selected.push(...this.rowsMantenedor);
			this.selected = [...this.selected];
			this.selectedAllItemsInPage[this.page.pageNumber] = true;
		} else {
			this.rowsMantenedor.map((proveedor) => {
			this.selected = this.selected.filter(
				(selectedProveedor) => selectedProveedor.proveedorId !== proveedor.proveedorId
			);
			});
			this.selectedAllItemsInPage[this.page.pageNumber] = false;
		}
	}

	onSelect({ selected }) {
		this.selected.splice(0, this.selected.length);
		this.selected.push(...selected);
	}
	getId(row: Proveedor) {
		return row.proveedorId; 
	}
	setPage(pageInfo) {
		this.loading = true;
		this.page.pageNumber = pageInfo.offset;
		this.page.pageNumber += 1;

		this.proveedorService
			.getDataByPage(this.filter, this.page)
			.subscribe(
				(pagedData) => {
					let elements = pagedData.data as Proveedor[];
					this.ref.detectChanges();
					elements.forEach((row) => {});
					this.rowsMantenedor = [...elements];
					this.setPagefromResponse(this.page, pagedData);
					this.loading = false;
					this.ref.detectChanges();
				},
				(error) => {
					this.loading = false;
					this.currentSwal.icon = "error";
					this.currentSwal.title = "Error en la solicitud";
					this.currentSwal.text = this.utilities.setErrorMessageFromArray(error.error);
					this.currentSwal.fire();
				},
				() => {
					this.loading = false;
					this.ref.detectChanges();
				}
			)
			.add(() => {
				this.loading = false;
				this.componentStarted = true;
				this.ref.detectChanges();
			});
	}
	starterPage() {
		this.page.pageNumber = 0;
		this.page.pageSize = 10;
		this.selectedAllItemsInPage[this.page.pageNumber] = false;
	}
	setPagefromResponse(currentPage: Page, data: PagedResponse<Proveedor>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}

	searchElements(nombre: string) {
		this.loading = true;
		this.proveedorService.getDataByPage(this.filter, this.page).subscribe(
			(result) => {
				this.loading = false;
				let elements = result.data as Proveedor[];
				elements.forEach((row) => {});
				this.rowsMantenedor = [...elements];
			},
			(error) => {},
			() => {
				this.loading = false;
				this.ref.detectChanges();
			}
		);
	}

	changeSearchedRows(data) {
		if (data != null) {
			this.rowsMantenedor = data;
		}
	}

	filterConcordance(configCriterias, planFilter: ProveedorFilter, eventFilter): ProveedorFilter {
		configCriterias.forEach((criterio) => {
			if (criterio != eventFilter.criterio) {
				planFilter[criterio] = "";
			}
		});
		return planFilter;
	}

	searchElementsByFilter(event) {
		this.filter = this.filterConcordance(this.configLocal.barraBusqueda.criteriosKeys, this.filter, event);
		this.filter.razonSocial = event.razonSocial != null ? event.razonSocial : "";
		this.filter.rut = event.rut != null ? event.rut : "";
		this.filter.ciudad = event.ciudad != null ? event.ciudad : "";
		this.filter.comuna = event.comuna != null ? event.comuna : "";
		this.filter.giro = event.giro != null ? event.giro : "";
		this.filter.activo = event.registroActivo ? false : true;
		this.filter[event.criterio] = event.busqueda;
		this.filter.listadoEstadoProveedor = event.listadoEstadoProveedor;
		this.filter = this.utilities.clearOtherFilterCriterias(event.criterio, this.filter, this.configLocal);
		this.filter.tipoReferenciaId = event.listaCodigosReferenciaProveedores && event.listaCodigosReferenciaProveedores.length > 0 ? event.listaCodigosReferenciaProveedores : [];
		this.setPage({ offset: 0 });
	}

	exportToExcel() {
		this.getAllRowsByFilter(this.page, this.filter);
	}

	getAllRowsByFilter(currentPageRef: Page, currentFilter: ProveedorFilter) {
		let fullPage: Page = new Page();
		fullPage.pageSize = currentPageRef.totalElements;
		fullPage.pageNumber = 0;
		fullPage.totalElements = currentPageRef.totalElements;
		fullPage.totalPages = 1;
		this.loading = true;
		this.proveedorService.getDataByPage(currentFilter, fullPage).subscribe(
			(result) => {
				let elements = result.data as Proveedor[];
				this.ref.detectChanges();
				elements.forEach((row) => {});
				this.loading = false;
				this.ref.detectChanges();
				this.exportExcelData(elements);
			},
			(error) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error al exportar";
				this.currentSwal.text = "No es posible exportar los datos. Intente mas tarde. ";
				if (error.error.message) {
					this.currentSwal.text += this.utilities.setErrorMessageFromArray(error.error);
				}
			},
			() => {
				this.loading = false;
				this.ref.detectChanges();
			}
		);
	}

	exportExcelData(arrayToExport: Array<Proveedor>): void {
		let arregloExportar = [];
		arrayToExport.forEach((item) => {
			let elementToExport = {};
			elementToExport["Razon Social"] = item.razonSocial;
			elementToExport["Rut"] = item.rut;
			elementToExport["Dv"] = item.dv;
			elementToExport["Giro"] = item.giro;
			elementToExport["Direccion Facturacion"] = item.dirFact;
			elementToExport["Correo Particular"] = item.correoPar;
			elementToExport["Ciudad"] = item.ciudad;
			elementToExport["Comuna"] = item.comuna;
			elementToExport["Casilla Recepción Dte"] = item.correoFact;
			arregloExportar.push(elementToExport);
		});
		this.utilities.exportAsExcelFile(arregloExportar, "Proveedores");
	}

	detailModal(modalRef, row: Proveedor) {
		this.loading = true;
		this.proveedorToShow = row;
		this.loading = false;
		this.ref.detectChanges();
		this.detailProveedorModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}
	addProveedorModal(modalRef) {
		this.loading = true;
		this.newRut = "";
		this.newRazonSocial = "";
		this.newCiudad = "";
		this.newComuna = "";
		this.newCorreoPart = "";
		this.newDirFact = "";
		// this.newDirPart = "";
		this.newGiro = "";
		this.newCasilla = "";
		this.newAcuseReciboAutomatico = false;
		this.newListaProveedor = null;
		this.loading = false;
		this.ref.detectChanges();
		this.addNewProveedorModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}

	addProveedor(addForm) {
		this.loading = true;
		var newProveedor: Proveedor = new Proveedor();
		newProveedor.rut = parseInt(this.newRut.substring(0, this.newRut.length - 2));
		newProveedor.dv = this.newRut.substring(this.newRut.length - 1);
		newProveedor.razonSocial = this.newRazonSocial;
		newProveedor.giro = this.newGiro;
		newProveedor.comuna = this.newComuna;
		newProveedor.ciudad = this.newCiudad;
		newProveedor.correoPar = this.newCorreoPart;
		newProveedor.dirFact = this.newDirFact;
		newProveedor.emisorId = this.emisorId;
		newProveedor.correoFact = this.newCasilla;
		newProveedor.acuseReciboAutomatico = this.newAcuseReciboAutomatico;
		(newProveedor as any).listaProveedor = this.newListaProveedor;
		// newProveedor.dirPart = this.newDirPart;
		this.proveedorService.agregarProveedor(newProveedor).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Proveedor Agregado",
					showCloseButton: true,
					html: "<div style='text-align:center;'><p>" + "El proveedor " + newProveedor.razonSocial + " fue agregado correctamente" + "</p></div>",
				});
				this.addNewProveedorModal.close();
				this.setPage({ offset: 0 });
			},
			(err) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error al agregar Proveedor";
				this.currentSwal.text = "No fue posible agregar al proveedor " + newProveedor.razonSocial + ". Intenta más tarde." + this.utilities.setErrorMessageFromArray(err.error);
				this.currentSwal.fire();
			}
		);
	}

	editModal(modalRef, row: Proveedor) {
		this.loading = true;
		this.proveedorToEdit.razonSocial = row.razonSocial;
		this.proveedorToEdit.comuna = row.comuna;
		this.proveedorToEdit.ciudad = row.ciudad;
		this.proveedorToEdit.correoPar = row.correoPar;
		this.proveedorToEdit.dirFact = row.dirFact;
		// this.proveedorToEdit.dirPart = row.dirPart;
		this.proveedorToEdit.rutProveedor = row.rutProveedor;
		this.proveedorToEdit.proveedorId = row.proveedorId;
		this.proveedorToEdit.giro = row.giro;
		this.proveedorToEdit.correoFact = row.correoFact;
		this.proveedorToEdit.acuseReciboAutomatico = row.acuseReciboAutomatico;
		this.proveedorToEdit.listaProveedor = row.listaProveedor ?? ListaProveedorEnum.Desconocido;
		this.loading = false;
		this.ref.detectChanges();
		this.editProveedorModal = this.modalService.open(modalRef, {
			windowClass: "",
			size: "lg",
			centered: true,
		});
	}

	editProveedor(addForm) {
		this.loading = true;
		this.proveedorService.actualizarProveedor(this.proveedorToEdit).subscribe(
			(res) => {
				this.loading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "success",
					title: "Proveedor Actualizado",
					showCloseButton: true,
					html: "<div style='text-align:center;'><p>" + "El proveedor " + this.proveedorToEdit.razonSocial + " fue actualizado correctamente" + "</p></div>",
				});
				this.editProveedorModal.close();
				this.setPage({ offset: 0 });
			},
			(err) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error al Actualizar Proveedor";
				this.currentSwal.text = "No fue posible actualizar al proveedor " + this.proveedorToEdit.razonSocial + ". Intenta más tarde." + this.utilities.setErrorMessageFromArray(err.error);
				this.currentSwal.fire();
			}
		);
	}

	rulesModal(ruleModalRef, row) {
		this.proveedorToShow = row;
		this.loading = true;
		let groupedSubscriptions = zip(this.proveedorService.getXmlTagsListByProveedor(row.emisorId, row.proveedorId), this.proveedorService.getCodesReferenceListByProveedor(row.emisorId, row.proveedorId));
		groupedSubscriptions
			.subscribe(
				(resultArray) => {
					this.proveedorToShow.xmlTagsRules = resultArray[0].data;
					this.proveedorToShow.codeReferenceRules = resultArray[1].data;
					this.rulesProveedorModalRef = this.modalService.open(ruleModalRef, {
						windowClass: "",
						size: "xl",
						centered: true,
					});
				},
				(error) => {
					Swal.fire({
						icon: "error",
						title: "Error",
						text: this.utilities.setErrorMessageFromArray(error.error),
					});
				}
			)
			.add(() => {
				this.loading = false;
				this.ref.detectChanges();
			});
	}

	closeRulesModal() {
		this.rulesProveedorModalRef.close();
	}

	getXMLTagList() {
		this.proveedorService.getXmlTagsCompleteList().subscribe(
			(result) => {
				this.localStorage.saveXmlTagList(result.data);
			},
			(error) => {
				Swal.fire({
					icon: "error",
					title: "Error en Proveedores",
					text: this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	getCodeReferencesList() {
		this.loading = true;
		this.proveedorService.getCodesReferenceCompleteList().subscribe(
			(result) => {
				this.localStorage.saveCodeReferenceList(result.data);
				let codeRefs = result.data;
				this.codeReferences = codeRefs as TipoReferencium[];
				this.loading = false;
				this.ref.detectChanges();
			},
			(error) => {
				Swal.fire({
					icon: "error",
					title: "Error en Proveedores",
					text: this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	sendRulesRequest(event: ProveedorRulesRequest) {
		this.loading = true;
		let tagsRequest = this.proveedorService.sendTagRulesRequest(event);
		let referenceCodeRequest = this.proveedorService.sendReferenceRulesRequest(event);
		let groupedSubscriptions = zip(tagsRequest, referenceCodeRequest);
		tagsRequest
			.subscribe(
				(result) => {
					referenceCodeRequest.subscribe(
						(result) => {
							Swal.fire({
								icon: "success",
								title: "Reglas de Recepción de Documentos guardadas",
								text: "Se han guardado correctamente las reglas para recepción de documentos del proveedor",
							});
						},
						(error) => {
							Swal.fire({
								icon: "error",
								title: "Error al guardar reglas",
								text: "No fue posible guardar las reglas para recepción de documentos de este Proveedor." + this.utilities.setErrorMessageFromArray(error.error),
							});
						}
					);
				},
				(error) => {
					Swal.fire({
						icon: "error",
						title: "Error al guardar reglas",
						text: "No fue posible guardar las reglas para recepción de documentos de este Proveedor." + this.utilities.setErrorMessageFromArray(error.error),
					});
				}
			)
			.add(() => {
				this.loading = false;
				this.ref.detectChanges();
				this.proveedorToShow = undefined;
				this.rulesProveedorModalRef.close();
			});
	}
	toggleExpandRow(row) {
		this.tableRef.rowDetail.toggleExpandRow(row);
	}

	activateProvider(row: Proveedor) {
		this.loading = true;
		this.proveedorService.activateProvider(row.proveedorId).subscribe(
			(res) => {
				if (res.data) {
					Swal.fire({
						icon: "success",
						title: "Proveedor Activado",
						showCloseButton: true,
						html: "<div style='text-align:center;'><p>" + "Proveedor " + row.razonSocial + " Activado" + "</p></div>",
					});
					this.setPage({ offset: 0 });

					this.loading = false;
					this.ref.detectChanges();
				}
			},
			(err) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error al Activar";
				this.currentSwal.text = "No fue posible activar el Proveedor " + row.razonSocial + this.utilities.setErrorMessageFromArray(err.error);
				this.currentSwal.fire();
			}
		);
	}

	deactivateProvider(row: Proveedor) {
		this.loading = true;
		this.proveedorService.deactivateProvider(row.proveedorId).subscribe(
			(res) => {
				if (res.data) {
					this.loading = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "success",
						title: "Proveedor Desactivado",
						showCloseButton: true,
						html: "<div style='text-align:center;'><p>" + "Proveedor " + row.razonSocial + " Desactivado" + "</p></div>",
					});

					this.setPage({ offset: 0 });
				}
			},
			(err) => {
				this.loading = false;
				this.ref.detectChanges();
				this.currentSwal.icon = "error";
				this.currentSwal.title = "Error al Desactivar";
				this.currentSwal.text = "No fue posible desactivar al Proveedor " + row.razonSocial + this.utilities.setErrorMessageFromArray(err.error);
				this.currentSwal.fire();
			}
		);
	}
	cambiarEstadoListaProveedores(TipoProveedor: ListaProveedorEnum, proveedores?: Proveedor[]) {
		const targetProveedores = (proveedores && proveedores.length > 0) ? proveedores : this.selected;

		if (!targetProveedores || targetProveedores.length === 0) {
			Swal.fire({
				icon: 'error',
				title: 'Sin selección',
				text: 'Seleccione al menos un proveedor.',
			});
			return;
		}

		const listaTexto = TipoProveedor === ListaProveedorEnum.ListaBlanca ? 'lista blanca' : 'lista negra';

		const ids = targetProveedores.map((p) => p.proveedorId);

		Swal.fire({
			icon: 'question',
			title: 'Confirmar acción',
			text: `¿Desea agregar ${ids.length} proveedor(es) a la ${listaTexto}?`,
			showCancelButton: true,
			confirmButtonText: 'Sí, continuar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#1BC5BD',
			cancelButtonColor: '#F64E60',
		}).then((result) => {
			if (!result.isConfirmed) {
				return;
			}

			this.loading = true;

			this.proveedorService.actualizarListaProveedores(ids, TipoProveedor).subscribe(
				(res) => {
					this.loading = false;
					this.ref.detectChanges();

					Swal.fire({
						icon: 'success',
						title: ids.length > 1 ? 'Proveedores actualizados' : 'Proveedor actualizado',
						html: `<div style='text-align:center;'>
									<p>${ids.length > 1 ? 'Los proveedores seleccionados fueron agregados'
									: 'El proveedor fue agregado'} a la ${listaTexto}.</p>
							</div>`,
					});
					if (!proveedores) {
						this.selected = [];
						this.selectedAllItemsInPage = {};
					}
					this.setPage({ offset: this.page.pageNumber - 1 < 0 ? 0 : this.page.pageNumber - 1 });
				},
				(err) => {
					this.loading = false;
					this.ref.detectChanges();

					this.currentSwal.icon = 'error';
					this.currentSwal.title = 'Error al actualizar proveedores';
					this.currentSwal.text = this.utilities.setErrorMessageFromArray(err.error);
					this.currentSwal.fire();
				}
			);
		});
	}

}
